module.exports = __webpack_public_path__ + "img/warning.c5a4c049.svg";